module.exports = require("core-js-pure/features/instance/splice");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/splice.js
// module id = 483
// module chunks = 13